(function () {
    'use strict';

    angular
        .module('app.core')
        .decorator('uibDatepickerPopupDirective', uibDatepickerPopupDecorator);

    var isUndefined = angular.isUndefined,
        isDate = angular.isDate;

    uibDatepickerPopupDecorator.$inject = ['$delegate'];
    function uibDatepickerPopupDecorator($delegate) {
        var originalCompile = $delegate[0].compile;
        $delegate[0].compile = compile;
        return $delegate;

        function compile(scope, element, attrs, ctrls) {
            var originalLink = originalCompile.apply(this, arguments);

            return function link(scope, element, attrs, ctrls) {
                var ctrl = ctrls[0];
                originalLink.apply(this, arguments);
                scope.$on('$localeChangeSuccess', localeChangeSuccess);
                if (ctrl) 
                    addValidators();

                //////////////////////////////////////

                function localeChangeSuccess() {
                    scope.dateSelection(scope.date);
                }

                function addValidators() {
                    ctrl.$validators.minDate = minDate;
                    ctrl.$validators.maxDate = maxDate;

                    function minDate(value) {
                        var minVal = scope.datepickerOptions.minDate;
                        return !isValidDate(value) || !isValidDate(minVal) || value >= minVal;
                    };
                    function maxDate(value) {
                        var maxVal = scope.datepickerOptions.maxDate;
                        return !isValidDate(value) || !isValidDate(maxVal) || value <= maxVal;
                    };
                }

                function isValidDate(value) {
                    return isDate(value) && !isNaN(value.getTime());
                }
            };
        }
    }
})();